import styled from 'styled-components';

import { setMobileView } from '../../tools/mobileView';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const MessageDataContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

export const MessageContainer = styled.div`
    margin: 40px 0;
    padding: 20px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: ${setMobileView() ? 'column' : 'row'};
    margin: 20px 0;
`;

export const ContactInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    margin: 0 40px;
`;

export const MessageTitle = styled.h2`

`;

export const BackText = styled.h4`
    text-align: start;
    cursor: pointer;
`;

export const ContactInfoText = styled.h4`
    margin: 1px;
    padding: 2px;
`;

export const ContactInfoMessage = styled.h5`

`;

export const DeleteMessageButton = styled.button`
    font-family: 'Open Sans Condensed';
    font-weight: bolder;
    text-transform: uppercase;
    color: #fff;
    background-color: ${props => props.color};
    border: none;
    border-radius: 2px;
    margin-top: 10px;
    height: 50px;
    width: 100px;

    &:hover {
        color: ${props => props.color};
        background-color: #fff;
        border: ${props => props.color} solid 1px;
    }
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const NoteCard = styled.div`
  border: 1px solid #ccc;
  padding: 10px;
  margin-top: 10px;
  cursor: pointer;
  border-radius: 4px;
  background-color: #fff;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  }
`;

export const NoteCardTitle = styled.p`
  font-weight: bold;
  margin-bottom: 6px;
`;

export const NoteCardContent = styled.p`
  color: #333;
  font-size: 14px;
`;

export const Field = styled.div`
  margin: 8px 0;
  font-size: 14px;
  width: 100%;
  max-width: 600px;
  text-align: left;
  line-height: 1.5;

  strong {
    font-weight: 600;
    display: inline-block;
    min-width: 90px;
  }
`;